/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';
import { Box, Text } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const Tag = ({ label, compact, onClick, success, warning, error, className, children, icon, ...rest }) => {
	const classes = classnames(
		'tag',
		{ 'is-compact': compact, 'is-success': success, 'is-warning': warning, 'is-error': error },
		className,
	);

	if (onClick) {
		return (
			<button onClick={onClick} className={classes} {...rest}>
				<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
					<Text size='xsmall'>{label}</Text>
					{icon && <Icon {...icon} />}
				</Box>
				{children}
			</button>
		);
	}

	return (
		<Box className={classes} {...rest}>
			<Box display='flex' alignItems='center' justifyContent='spaceBetween'>
				<Text size='xsmall'>{label}</Text>
				{icon && <Icon {...icon} />}
			</Box>
			{children}
		</Box>
	);
};

Tag.defaultProps = {
	compact: false,
	label: '',
};

export default Tag;
